import React from 'react';

export const FlatsFiltersContentContext = React.createContext({});
export const FlatsFiltersOpenedContext = React.createContext({});
export const FlatsFiltersEmptyStatesContext = React.createContext({});
